export enum EnumCajuInterest {
  ALREADY_KNOW = "Já conheço a Caju e quero contratar :)",
  MAKE_APOINTMENT = "Agendar reunião para conhecer e tirar dúvidas",
  SIGNUP_TEST = "Quero contratar (teste)",
  WATCH_DEMO = "Assistir demonstração para conhecer e tirar dúvidas",
}
